

export default (function () {
  return "";
});